/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Injector } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OverlayModule } from '@angular/cdk/overlay';
import { appInjector } from './pages/shared/app-injector.global';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { CultureService } from './services/culture.service';
import { CacheService } from './services/cache.service';
import { TranslationLoaderFactory } from './services/translate/kiosk-translate.loader';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    OverlayModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslationLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  bootstrap: [AppComponent],
  providers: [CultureService, { provide: APP_BASE_HREF, useValue: '/' }]
})
export class AppModule {
  constructor(injector: Injector, private _translate: TranslateService, private _cache: CacheService) {
    appInjector(injector);
    this._translate.setDefaultLang('en');    
    
    //TODO: Do we keep it local, or move these into the user settings eventually?
    //UPDATE: We need to have this functionality moved to the users and table
    let lang = this._cache.get("UserLanguageSelection");
    if (lang) {
        this._translate.use(lang);
    } else {
      this._translate.use('en');
    }
  }
}
